import * as React from 'react';

import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '../lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    label?: string;
    dataTestId?: string;
  }
>(({ className, label, dataTestId, ...props }, ref) => (
  <SwitchPrimitives.Root
    data-testid={dataTestId}
    className={cn(
      'vai-peer vai-group vai-inline-flex vai-h-6 vai-w-11 vai-shrink-0 vai-cursor-pointer vai-items-center vai-rounded-full vai-border-2 vai-border-transparent vai-transition-colors focus-visible:vai-outline-none focus-visible:vai-ring-2 vai-relative focus-visible:vai-ring-ring focus-visible:vai-ring-offset-2 focus-visible:vai-ring-offset-background disabled:vai-cursor-not-allowed disabled:vai-opacity-50 data-[state=checked]:vai-bg-sapphire-500 data-[state=unchecked]:vai-bg-input',
      className,
    )}
    {...props}
    ref={ref}
  >
    {label && (
      <span className="vai-absolute vai-text-[12px] vai-font-inter vai-font-bold vai-top-1/2 vai-transform vai--translate-y-1/2 vai-pointer-events-none group-data-[state=checked]:vai-left-1.5 group-data-[state=unchecked]:vai-left-[1.5rem] group-data-[state=checked]:vai-text-white group-data-[state=unchecked]:vai-text-gray-700">
        {label}
      </span>
    )}
    <SwitchPrimitives.Thumb
      className={cn(
        'vai-pointer-events-none vai-block vai-h-5 vai-w-5 vai-rounded-full vai-bg-background vai-shadow-lg vai-ring-0 vai-transition-transform data-[state=checked]:vai-translate-x-5 data-[state=unchecked]:vai-translate-x-0',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
